import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/70">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
            <div>
              <span className="font-heading text-lg font-bold text-primary-600">韩漫漫画网</span>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                韩漫漫画网汇集韩国漫画大全，推荐最新热门韩国漫画，提供无删减韩国漫画排行榜，帮助您快速找到优质漫画，享受免费阅读乐趣。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-categories" className="text-foreground-900 no-underline">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.filter((c) => c.slug !== 'all').slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-links" className="text-foreground-900 no-underline">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    全部漫画
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#top" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    返回顶部
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-contact" className="text-foreground-900 no-underline">联系方式</a>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-base text-primary-500" />
                  <span>contact@hanmancomic.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-line text-base text-primary-500" />
                  <span>www.hanmancomic.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-base text-primary-500" />
                  <span>每日更新</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩漫漫画网. 版权所有.
            </p>
            <p className="text-xs text-foreground-500">
              <strong>韩国漫画大全</strong> · 最新热门韩国漫画推荐 · 无删减韩国漫画排行榜
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}